export var ExperimentStatisticsEntity;
(function (ExperimentStatisticsEntity) {
    ExperimentStatisticsEntity["TriggerCount"] = "triggerCount";
    ExperimentStatisticsEntity["Revenue"] = "revenue";
    ExperimentStatisticsEntity["ConversionRate"] = "conversionRate";
    ExperimentStatisticsEntity["RevenuePerSession"] = "revenuePerSession";
})(ExperimentStatisticsEntity || (ExperimentStatisticsEntity = {}));
